import React from 'react'
import { StaticImage } from "gatsby-plugin-image"

const OurHistory = () => {
    return (
        <section className="history-area ptb-100 bg-e7edf9">
            <div className="container">
                <div className="section-title">
                    <h2>History Begins in 2016</h2>
                </div>

                <ol className="timeline history-timeline">
                    <li className="timeline-block">
                        <div className="timeline-date">
                            <span>2016</span>
                        </div>

                        <div className="timeline-icon">
                            <span className="dot-badge"></span>
                        </div>

                        <div className="timeline-content">
                            <div className="row align-items-center">
                                <div className="col-lg-7 col-md-12">
                                    <div className="content">
                                        <h3>The Idea Was Born</h3>
                                        <p>Tafoma - our new digital workspace software: created out of our collective need for a more user-friendly and collaborative workplace environment.</p>
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-12">
                                    <div className="image">
                                        <StaticImage src={'../../assets/images/about/history1.png'} 
                                        alt="Person next to lightbulb." 
                                        formats={["AUTO", "WEBP", "AVIF"]}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li className="timeline-block">
                        <div className="timeline-date">
                            <span>2018</span>
                        </div>

                        <div className="timeline-icon">
                            <span className="dot-badge"></span>
                        </div>

                        <div className="timeline-content">
                            <div className="row align-items-center">
                                <div className="col-lg-7 col-md-12">
                                    <div className="content">
                                        <h3>Beta Public Release</h3>
                                        <p>We were ready to show our all-in-one, streamlined platform to the public. We wanted everyone to experience how our non-integrative software solution would revolutionise their team and project management.</p>
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-12">
                                    <div className="image">
                                        <StaticImage src={'../../assets/images/about/history2.png'} 
                                        alt="Two people siting on a cloud." 
                                        formats={["AUTO", "WEBP", "AVIF"]}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li className="timeline-block">
                        <div className="timeline-date">
                            <span>2020</span>
                        </div>

                        <div className="timeline-icon">
                            <span className="dot-badge"></span>
                        </div>

                        <div className="timeline-content">
                            <div className="row align-items-center">
                                <div className="col-lg-7 col-md-12">
                                    <div className="content">
                                        <h3>Tafoma 1.0 General Public Release</h3>
                                        <p>Equipped with positive feedback from end-users we worked hard to polish and evolve the software, and could finally head out of beta. With Tafoma we had created a single, efficient web-based tool that brought together every workplace need; an elegantly designed digital solution that makes productivity and efficiency easy. All you need for project tracking, management, and collaboration within a single platform without requiring third party integration: fall in love with the digital workplace evolution with Tafoma.</p>
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-12">
                                    <div className="image">
                                    <StaticImage src={'../../assets/images/about/history3.png'} 
                                        alt="Person next to phone." 
                                        formats={["AUTO", "WEBP", "AVIF"]}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ol>
            </div>
        </section>
    )
}

export default OurHistory